import type { HotelDetailsReviewView } from '../models.js';

export function HotelDetailsReviews({
  label,
  reviews,
}: {
  readonly label: string;
  readonly reviews: readonly HotelDetailsReviewView[];
}) {
  if (reviews.length === 0) return null;

  const initials = (author: string) =>
    author
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part[0])
      .join('')
      .toUpperCase();

  return (
    <section className="genui2 hui-hotel-details-reviews">
      <h3>{label}</h3>
      <div className="hui-hotel-details-review-list">
        {reviews.map((review) => (
          <article key={review.id} className="hui-hotel-details-review">
            <span className="hui-hotel-details-review-avatar" aria-hidden="true">
              {initials(review.author)}
            </span>
            <header>
              {review.ratingLabel && <strong>★ {review.ratingLabel}</strong>}
              <span>
                {review.author}
                {review.dateLabel && ` · ${review.dateLabel}`}
              </span>
            </header>
            <p>{review.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
